export enum IconTextColumnCount {
  One = 'one',
  Two = 'two',
  Three = 'three',
  Four = 'four',
  Auto = 'auto'
}
